/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC } from "react";
import { ConfirmModal } from "@advapacs/common";
import { Trans, useTranslation } from "react-i18next";

export interface SupportModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  showModal: boolean;
}

export const SupportConfirmModal: FC<SupportModalProps> = ({
  onConfirm,
  onCancel,
  showModal = false,
}) => {
  const { t } = useTranslation("modal");

  return (
    <>
      {showModal && (
        <ConfirmModal
          icon={
            <span className="flex-center support-icon">
              <i className="fas fa-headset fa-2x text-success" />
            </span>
          }
          size="lg"
          show={showModal}
          onClose={onCancel}
          header={t("support.header")}
          body={
            <>
              <div className="form-group">
                <div className="row pt-1 pb-2 justify-content-center">
                  <span className="text-center">{t("support.title")}</span>
                </div>
                <div className="support-modal-content">
                  <div className="w-100">
                    <div>
                      <p className="font-weight-bold mb-2">
                        <i className="fas fa-check mr-2 text-success" />
                        {t("support.term_one")}
                      </p>
                      <ul className="ml-1">
                        <li>{t("support.term_line_one")}</li>
                        <li>{t("support.term_line_two")}</li>
                        <li>{t("support.term_line_three")}</li>
                      </ul>
                    </div>

                    <div className="mt-2">
                      <p className="font-weight-bold mb-2">
                        <i className="fas fa-ban mr-2 text-danger" />
                        {t("support.term_two")}
                      </p>
                      <ul className="ml-1">
                        <li>{t("support.term_two_line_one")}</li>
                        <li>
                          {t("support.term_two_line_two")}
                          <br />
                          <span className="text-gray">
                            <em>
                              <Trans
                                i18nKey={t("support.term_two_note")}
                                components={{ strong: <strong /> }}
                              />
                            </em>
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="mt-2">{t("support.footer_note")} </div>
                  </div>
                </div>
              </div>
            </>
          }
          confirmBtnName={t("modal:support.confirm_name")}
          confirmBtnVariant="primary"
          cancelBtnName={t("cancel")}
          cancelBtnVariant="secondary"
          cancel={onCancel}
          confirm={onConfirm}
        />
      )}
    </>
  );
};
